export enum OpnameDuur {
    drieDagen = '3',
    eenDag = '1',
    tweeDagen = '2',
    zevenDagen = '7',
}
export const opnameDuurOptions: OpnameDuur[] = [OpnameDuur.eenDag, OpnameDuur.tweeDagen, OpnameDuur.drieDagen];
